const ID_TOKEN_KEY = "id_token";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = (token) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

// Helper function to check if token exists and is potentially valid
export const isTokenAvailable = () => {
  const token = getToken();
  return token && token.trim() !== "";
};

// Helper function to decode JWT token (basic decoding without verification)
export const decodeToken = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const payload = token.split(".")[1];
    const decodedPayload = atob(payload);
    return JSON.parse(decodedPayload);
  } catch (error) {
    return null;
  }
};

// Helper function to check if token is expired (client-side check)
export const isTokenExpired = () => {
  const decoded = decodeToken();
  if (!decoded || !decoded.exp) return true;

  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp < currentTime;
};

export default {
  getToken,
  saveToken,
  destroyToken,
  isTokenAvailable,
  decodeToken,
  isTokenExpired,
};
